/**
 * Generator that returns triple of subsequent values in the given array.
 * @param array source array
 * @returns triple of previous, current and next value on every call
 */
function* triple<T>(array: T[]): Generator<{ prev?: T; current: T; next?: T }, undefined, unknown> {
  for (let i = 0; i < array.length; i += 1) {
    yield { prev: array[i - 1], current: array[i], next: array[i + 1] };
  }
  return undefined;
}

export default triple;
